import { formatDate } from '@mobi/utils/date'
import type { IdentifiableRace } from '@core/Areas/Racing/Types'
import type { RaceIdentifierString } from './types'

export function makeRaceIdentifier({
  meetingDate,
  meetingId,
  raceNumber,
}: IdentifiableRace): RaceIdentifierString {
  return `${formatDate(meetingDate, 'YYYYMMDD')}/${meetingId}/${raceNumber}`
}
